import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { serverUrl } from "../nestserver";

/* -------------------------------------------------------------------------- */
/*                         Create Permission Request                          */
/* -------------------------------------------------------------------------- */

export function useCreatePermissionRequest(mutationOptions) {
  function createPermissionRequest(data) {
    return axios.post(`${serverUrl}/instructor-permission/request`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    });
  }

  return useMutation(createPermissionRequest, mutationOptions);
}

/* -------------------------------------------------------------------------- */
/*                    Get Permissions by Instructor ID                        */
/* -------------------------------------------------------------------------- */

export function useGetPermissionsByInstructor(
  instructorId,
  queryOptions = {},
  params = {},
) {
  async function getPermissionsByInstructor() {
    if (!instructorId) return [];

    const config = {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        "Access-Control-Allow-Origin": "*",
      },
      params: params,
    };

    const res = await axios.get(
      `${serverUrl}/instructor-permission/instructor/${instructorId}`,
      config,
    );
    return res.data;
  }

  return useQuery(
    ["permissionsByInstructor", instructorId, params],
    getPermissionsByInstructor,
    {
      enabled: !!instructorId,
      ...queryOptions,
    },
  );
}

/* -------------------------------------------------------------------------- */
/*                         Get All Permissions                                */
/* -------------------------------------------------------------------------- */

export function useGetAllPermissions(queryOptions = {}, params = {}) {
  async function getAllPermissions() {

    const config = {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        "Access-Control-Allow-Origin": "*",
      },
      params: params,
    };

    const res = await axios.get(`${serverUrl}/instructor-permission`, config);

    return res.data;
  }

  return useQuery(["allPermissions", params], getAllPermissions, {
    enabled: true,
    ...queryOptions,
  });
}

/* -------------------------------------------------------------------------- */
/*                       Update Permission Status                             */
/* -------------------------------------------------------------------------- */

export function useUpdatePermissionStatus(mutationOptions) {
  function updatePermissionStatus({ requestId, data }) {
    return axios.put(
      `${serverUrl}/instructor-permission/status/${requestId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      },
    );
  }

  return useMutation(updatePermissionStatus, mutationOptions);
}

/* -------------------------------------------------------------------------- */
/*                    Get Permission Detail by ID                             */
/* -------------------------------------------------------------------------- */

export function useGetPermissionDetail(requestId, queryOptions = {}) {
  async function getPermissionDetail() {
    if (!requestId) return null;

    const res = await axios.get(
      `${serverUrl}/instructor-permission/${requestId}`,
      {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      },
    );
    return res.data;
  }

  return useQuery(["permissionDetail", requestId], getPermissionDetail, {
    enabled: !!requestId,
    ...queryOptions,
  });
}
